'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
    var isPublic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var WithUploadSign = function (_React$Component) {
        _inherits(WithUploadSign, _React$Component);

        function WithUploadSign() {
            _classCallCheck(this, WithUploadSign);

            return _possibleConstructorReturn(this, (WithUploadSign.__proto__ || Object.getPrototypeOf(WithUploadSign)).apply(this, arguments));
        }

        _createClass(WithUploadSign, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.dispatch((0, _upload_sign.fetchUploadSignIfNeeded)(isPublic));
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }]);

        return WithUploadSign;
    }(_react2.default.Component);

    WithUploadSign.propTypes = {
        auth: _react2.default.PropTypes.object.isRequired
    };
    var mapStateToProps = function mapStateToProps(store) {
        var auth = store.auth;
        return {
            auth: auth
        };
    };

    return (0, _reactRedux.connect)(mapStateToProps)(WithUploadSign);
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _upload_sign = require('../actions/upload_sign');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


//////////////////
// WEBPACK FOOTER
// ./src/js/hocs/with_upload_sign.js
// module id = 1342
// module chunks = 0